import {
  Map,
  Marker,
  FullscreenControl,
  NavigationControl,
} from 'react-map-gl/maplibre';
import { useEffect, useState } from 'react';
import { Box, MenuItem, TextField, Typography } from '@material-ui/core';

import {
  CoverageStatus,
  MAP_CENTER,
  MAP_ZOOM,
} from '../../../../business/cargo';
import { MAP_STYLE } from 'constants/MapConfig';
import { Disclaimer } from './Disclaimer';
import { useCoverage, useRequestLang } from './hooks';
import { HouseIcon } from '../../../../components/icons/house-icon/HouseIcon';
import { RestaurantIcon } from '../../../../components/icons/restaurant-icon';
import { InputPlacesAutocompleteBackend } from 'features/cargo/components/location-service';

import useRequestStyles from './request.styles';
import 'maplibre-gl/dist/maplibre-gl.css';

export function Coverage() {
  const [viewState, setViewState] = useState({
    latitude: MAP_CENTER.lat,
    longitude: MAP_CENTER.lng,
  });

  const styles = useRequestStyles();
  const {
    pickupPointLabelText,
    deliveryAddressLabelText,
    coverageMapDisclaimerText,
  } = useRequestLang();
  const {
    deliveryAddress,
    selectedStore,
    stores,
    coverageStatus,
    deliveryCost,
  } = useCoverage();

  useEffect(() => {
    setViewState({
      latitude: deliveryAddress?.coordinates?.lat ?? MAP_CENTER.lat,
      longitude: deliveryAddress?.coordinates?.lng ?? MAP_CENTER.lng,
    });
  }, [deliveryAddress]);

  return (
    <>
      <Disclaimer
        coverageStatus={coverageStatus as CoverageStatus}
        deliveryCost={deliveryCost}
      />
      <Box
        display='flex'
        flexDirection='column'
        gridGap='0.5rem'
        margin='1.25rem 0'
      >
        <TextField
          classes={{ root: styles.disabled }}
          defaultValue={selectedStore ? selectedStore.id : ''}
          label={pickupPointLabelText}
          variant='outlined'
          disabled
          select
        >
          {stores.map(option => (
            <MenuItem key={`s-${option.id}`} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
        {selectedStore?.address && (
          <Typography className={styles.addressLabel}>
            {selectedStore?.address}
          </Typography>
        )}
        <InputPlacesAutocompleteBackend
          defaultValue={deliveryAddress?.completeAddress}
          onChange={undefined}
          label={deliveryAddressLabelText}
          variant='outlined'
          disabled
        />

        <Box width='100%' height='18.75rem' margin='1rem 0'>
          <Map
            mapStyle={MAP_STYLE}
            style={{ width: '100%', height: '100%' }}
            initialViewState={{
              zoom: MAP_ZOOM,
              latitude: selectedStore?.mapPoint.lat ?? MAP_CENTER.lat,
              longitude: selectedStore?.mapPoint.lng ?? MAP_CENTER.lng,
            }}
            onMove={evt => setViewState(evt.viewState)}
            {...viewState}
          >
            <Marker
              anchor='center'
              latitude={selectedStore?.mapPoint?.lat ?? MAP_CENTER.lat}
              longitude={selectedStore?.mapPoint?.lng ?? MAP_CENTER.lng}
            >
              <RestaurantIcon className={styles.restaurantIcon} />
            </Marker>
            <Marker
              anchor='center'
              latitude={deliveryAddress?.coordinates?.lat ?? MAP_CENTER.lat}
              longitude={deliveryAddress?.coordinates?.lng ?? MAP_CENTER.lng}
            >
              <HouseIcon />
            </Marker>
            <FullscreenControl />
            <NavigationControl />
          </Map>

          <Typography component='p' className={styles.mapDisclaimer}>
            {coverageMapDisclaimerText}
          </Typography>
        </Box>
      </Box>
    </>
  );
}
